import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import BreadCrumbComponent from "../Misc/BreadCrumb/BreadCrumbComponent";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getSingleCertifications,
  getSingleCertificationsResponse,
  getSingleCertificationsClear,
} from "../../../redux/certificateURL/actions";
import {
  getEventDetailsBroker,
  getEventDetailsBrokerClear,
  getEventDetailsNIIT,
  getEventDetailsNIITClear,
  getSessionNIITList,
  getSessionNIITListClear,
  getSessionBrokerList,
  getSessionBrokerListClear,
  getEnrollBrokerSession,
  getEnrollBrokerSessionClear,
  joinSession,
  joinSessionClear,
  setEnrollBrokerSessionResponse,
  eventNotification,
  checkEventNotification,
  eventNotificationClear,
  checkEventNotificationClear,
  cancelSessionData,
  cancelSessionDataClear,
  hostSessionClear,
  hostSession,
  sessionWatchURLDataClear,
  sessionWatchURLDataResponse,
  boardcastDataResponse,
  getCalendarSessionList,
  getEnrollAvailabilityClear,
  getEnrollAvailability,
} from "../../../redux/events/actions";
import {
  FreeForYou,
  FreePaidSubscription,
  SessionKeys,
  convertTimeInHourAndMin,
  formatEndDateTime,
  formatStartDateTime,
  getPriceInfoForEntity,
  SessionPrice,
  findUpcomingSession,
  clickStreamUser,
  isSessionWithinOneHour,
  convertTimeFormat,
  getProcureInfo,
  ProductCardPriceInfo,
  getSessionType,
} from "../../../utils/AppUtils";
import Loader from "../../Loader/Loader";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import Dropdown from "react-bootstrap/Dropdown";
import ErrorSectionSidebar from "../../ErrorPage/ErrorSectionSideBar";
import CartPopUpComponent from "../DetailPage/CartPopUp/CartPopUpComponent";
import SessionActionButtonComponent from "../Misc/SessionActionButton/SessionActionButtonComponent";
import ConfirmModal from "../../modal/ConfirmModal";
import { Spinner } from "react-bootstrap";
import useLogin from "../../../custom-hooks/useLogin";
import { routeList } from "../../../utils/routeList";
import { setCurrentView } from "../../../redux/assignCourse/actions";
import AssignCourseModal from "../../modal/AssignCourseModal";
import RightPanelComponent from "../DetailPage/DetailPageRightPanel/RightPanelComponent";
import { isAndroid, isIOS } from "react-device-detect";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getActiveHeader } from "../../../redux/home/actions";
import NotFoundComponent from "../NotFound/NotFoundComponent";

function EventDetailsSection() {
  const [scrolled, setScrolled] = useState(false);
    
      useEffect(() => {
        const handleScroll = () => {
          const isScrolled = window.scrollY > 400;
          setScrolled(isScrolled);
    
          // Toggle class on <body> tag
          if (isScrolled) {
            document.body.classList.add("scrolled-body");
          } else {
            document.body.classList.remove("scrolled-body");
          }
        };
    
        window.addEventListener("scroll", handleScroll);
    
        // Call on mount in case user is already scrolled
        handleScroll();
    
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
          dispatch(getActiveHeader("learn"))
        }, 1000);
  }, []);

  const c = params.get("c");
  let eventId = "";
  let event_code = "";
  let source = "";
  let from = "";
  let lp_id = "";
  let fromCert = "";
  let type = "";
  let is_home = "";
  let providerId = "";
  let providerName = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    eventId = paramsReq.event_id;
    event_code = paramsReq.event_code;
    source = paramsReq.source;
    from = paramsReq.from;
    lp_id = paramsReq.lp_id;
    fromCert = paramsReq.fromCert;
    type = paramsReq.type;
    is_home = paramsReq?.is_home;
    providerId = paramsReq?.provider_id;
    providerName = paramsReq?.provider_name;
  }
  // const eventId = params.get('event_id');
  // const event_code = params.get('event_code');
  // const source = params.get('source');
  const authBroker = useSelector((state) => state.auth.authBroker);
  const sessionBrokerListRes = useSelector(
    (state) => state.events.sessionListBroker
  );

  const eventDetailResBroker = useSelector(
    (state) => state.events.eventDetailBroker
  );
  const sessionCancelledData = useSelector(
    (state) => state.events.sessionCancel
  );

  const [eventDetail, setEventDetail] = useState({});
  const eventsDetailRes = useSelector(
    (state) => state.certificateURL.singleCertification
  );
  const userRole = useSelector((state) => state.user.role);
  const checkNotified = useSelector((state) => state.events.checkNotified);
  const [show, setShow] = useState(false);
  const [selectedSession, setSelectedSession] = useState("");
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSessionLoading, setIsSessionLoading] = useState();
  const [title, setTitle] = useState("");
  const [sessionListing, setSessionListing] = useState([]);
  const [upcomingSessionListing, setUpcomingSessionListing] = useState([]);
  const [pastSessionListing, setPastSessionListing] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [upcomingSessionDetail, setUpcoming] = useState({});
  const notfiyEnrolled = useSelector((state) => state.events.eventNotification);
  const [notifyMeBtn, setNotifyMeBtn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [headerProdData, setHeaderProdData] = useState({});
  const [bannerPriceInfo, setBannerPriceInfo] = useState({ isFree: true });
  const [register, setRegister] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);

  const [isShowLoader, setIsShowLoader] = useState(false);

  const joinSessionData = useSelector((state) => state.events.joinSession);
  const hostSessionInfo = useSelector((state) => state.events.hostSession);
  const { isLoggedIn } = useLogin();

  const [breadCrumbData, setBreadCrumbData] = useState([
    { name: providerId ? authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
      authBroker?.payload?.user?.config?.partner_menu_text:
      "Learning Partners" : "Learn", active: false, link: providerId ? "/our-partners" : "/learn/courses?tab=1", isLoading: false },
    {
      name: fromCert === "true" ? "Certifications" : "Events",
      active: false,
      link: fromCert === "true" ? "/learn/certifications" : "/learn/events",
      isLoading: false,
    },
    { name: "-", active: false, link: "", isLoading: true },
  ]);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const enrollBrokerSession = useSelector(
    (state) => state.events.enrollBrokerSession
  );

  const addToCartRes = useSelector((state) => state.product.addToCart);

  const [showInfoModalMsg, setShowInfoModalMsg] = useState("");

  const [clickedItem, setClickedItem] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false)
  const [showModalMsg, setShowModalMsg] = useState('Would you like to unregister from the session?')
  const [sessionDataForModal, setSessionDataForModal] = useState({})


  useEffect(() => {
    if (source !== "broker" && isLoggedIn) {
      dispatch(
        checkEventNotification({
          module: "check-notified",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            event_id: eventId,
            origin: source === "broker" ? "broker" : "xsel",
          },
        })
      );
    }
  }, [source, isLoggedIn])
  useEffect(() => {
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);
  useEffect(() => {
    if (!_.isEmpty(addToCartRes)) {
      setIsSessionLoading(true);
      dispatch(
        getEventDetailsBroker({
          module: "eventDetailBroker",
          postData: {
            event_id: eventId,
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            origin: source === "broker" ? source : "ecom",
          },
        })
      );
      setIsLoading(false);
      sessionsApiCalling();
    }
  }, [addToCartRes]);

  useEffect(() => {
    sessionsApiCalling();
  }, [dispatch, authBroker, source, register,userDetails]);
  const sessionsApiCalling = () => {
    setIsLoading(true);
    if (!isLoggedIn || (!_.isEmpty(authBroker)&&!_.isEmpty(userDetailRes))) {
      if (source === "broker") {
        if (!_.isEmpty(authBroker))
          dispatch(
            getSessionBrokerList({
              module: "sessionBrokerList",
              postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                event_id: eventId,
                broker_id: authBroker?.payload?.user
                  ? authBroker?.payload?.user?.broker_id
                  : "",
                // providerId: providerId ? providerId : ''
              },
            })
          );
      } else {
        dispatch(
          getSingleCertifications({
            module: "getSingleCertifications",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              email: userDetails.email,
              event_id: event_code,
              user_id: localStorage.getItem(SessionKeys.USER_ID),
              company_id: userDetails.company_id,
              session_id: localStorage.getItem(SessionKeys.SESSION_ID),
            },
          })
        );
      }
    }
  };

  useEffect(() => {
    setIsSessionLoading(true);
    let reqBody = {
      event_id: eventId,
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      origin: source === "broker" ? source : "ecom",
    };
    if (from === "lp") {
      reqBody.lp_id = lp_id;
    }
    dispatch(
      getEventDetailsBroker({
        module: "eventDetailBroker",
        postData: reqBody,
      })
    );
  }, [dispatch, eventId, source]);

  useEffect(() => {
    if (!_.isEmpty(eventsDetailRes) && eventsDetailRes?.status === "success") {
      setIsLoading(false);
      let eventsListDetail = eventsDetailRes.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setSessionListing(eventsListDetail.sessionList);
        const upcomingSessionList = eventsListDetail.upcomingList;
        const pastList = eventsListDetail.pastSessionList;
        // setUpcomingSessionListing(upcomingSessionList);
        let timezoneAbbr = userDetails.timezoneAbbr;
        if(timezoneAbbr===undefined){
          timezoneAbbr = "America/New_York";
        }
        if (!_.isEmpty(upcomingSessionList)) {
          const sessionData = upcomingSessionList[0];
          setUpcoming(upcomingSessionList[0]);

          let priceInfo1 = getProcureInfo(sessionData.purchased_info);

          setBannerPriceInfo(priceInfo1);

          for (let session of upcomingSessionList) {
            session.can_enroll = true;
            session.hostZoomId = authBroker?.payload?.user
              ? authBroker.payload.user.zoom_id
              : "";
            session.userId = isLoggedIn ? authBroker.payload.user.user_id : "";
            // session.host = session.host;
            session.show_join = false;
            session.is_broadcast =
              session.delivery_mode === "virtual_broadcast";

            session.start_url = "";
            session.join_url = "";
            session.meeting_id = "";
            session.segmentId = "";
            session.timezoneAbbr = timezoneAbbr;
            if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
              for (let record of session.date_time) {
                if (record.start_date) {
                  session.segmentId = record.segment_id;
                  session.start_url = record.start_url ? record.start_url : "";
                  session.join_url =
                    session.delivery_mode === "blended_session"
                      ? record.inperson_meeting_url
                        ? record.inperson_meeting_url
                        : ""
                      : record.join_url
                        ? record.join_url
                        : "";
                  session.meeting_id = record.meeting_id;

                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                }
              }
              // console.log(session)
              session.date_time = _.sortBy(session.date_time, "startDateTime");
            }
          }
          setUpcomingSessionListing(upcomingSessionList);
        } else {
          setUpcoming({});
          setBannerPriceInfo({
            isFree: true,
          });
        }
        setUpcoming(
          upcomingSessionList.length > 0 ? upcomingSessionList[0] : {}
        );

        //for past session list
        if (!_.isEmpty(pastList)) {
          for (let session of pastList) {
            session.can_enroll = true;
            session.hostZoomId = authBroker?.payload?.user
              ? authBroker.payload.user.zoom_id
              : "";
            session.userId = isLoggedIn ? authBroker.payload.user.user_id : "";
            session.host = session.display_name;
            session.show_join = false;
            session.is_broadcast =
              session.delivery_mode === "virtual_broadcast";

            session.start_url = "";
            session.join_url = "";
            session.meeting_id = "";
            session.segmentId = "";
            session.timezoneAbbr = timezoneAbbr;
            if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
              for (let record of session.date_time) {
                if (record.start_date) {
                  session.segmentId = record.segment_id;
                  session.start_url = record.start_url ? record.start_url : "";
                  session.join_url =
                    session.delivery_mode === "blended_session"
                      ? record.inperson_meeting_url
                        ? record.inperson_meeting_url
                        : ""
                      : record.join_url
                        ? record.join_url
                        : "";
                  session.meeting_id = record.meeting_id;

                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                }
              }
              // console.log(session)
              session.date_time = _.sortBy(session.date_time, "startDateTime");
            }
          }
          setPastSessionListing(pastList);
        } else {
          setPastSessionListing([]);
        }
        setIsFetching(false);
      } else {
        setSessionListing([]);
        setUpcomingSessionListing([]);
        setPastSessionListing([]);
        setUpcoming({});
      }
      dispatch(getSingleCertificationsClear());
    }
  }, [eventsDetailRes]);

  useEffect(() => {
    console.log("eventdetail--", eventDetailResBroker);
    if (
      !_.isEmpty(eventDetailResBroker) &&
      eventDetailResBroker?.status === "success"
    ) {
      setIsSessionLoading(false);
      let eventsListDetail = eventDetailResBroker.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setEventDetail(eventsListDetail);
        setTitle(eventsListDetail.title);
        setIsFetching(false);
      } else {
        setEventDetail({});
        setTitle("");
        setIsFetching(false);
      }

      dispatch(getEventDetailsBrokerClear());
    }
  }, [eventDetailResBroker]);

  useEffect(() => {
    if (
      !_.isEmpty(sessionBrokerListRes) &&
      sessionBrokerListRes.status === "success"
    ) {
      setIsLoading(false);
      let eventsListDetail = sessionBrokerListRes.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setSessionListing(eventsListDetail.sessionList);
        const upcomingSessionList = eventsListDetail.upcomingList;
        const pastList = eventsListDetail.pastSessionList;
        // setUpcomingSessionListing(upcomingSessionList);
        setUpcoming(
          upcomingSessionList.length > 0 ? upcomingSessionList[0] : {}
        );
        setIsFetching(false);
        let timezoneAbbr = userDetails.timezoneAbbr;
        console.log("timezoneAbbr1: ",timezoneAbbr);
        if(timezoneAbbr===undefined){
          timezoneAbbr = "America/New_York";
        }
        for (let session of upcomingSessionList) {
          session.can_enroll = true;
          session.hostZoomId = isLoggedIn
            ? authBroker.payload.user.zoom_id
            : "";
          session.userId = isLoggedIn ? authBroker.payload.user.user_id : "";
          session.host = session.display_name;
          session.show_join = false;
          session.is_broadcast = session.delivery_mode === "virtual_broadcast";

          session.start_url = "";
          session.join_url = "";
          session.meeting_id = "";
          session.segmentId = "";
          session.timezoneAbbr = timezoneAbbr;
          if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
            for (let record of session.date_time) {
              if (record.start_date) {
                session.segmentId = record.segment_id;
                session.start_url = record.start_url ? record.start_url : "";
                session.join_url =
                  session.delivery_mode === "blended_session"
                    ? record.inperson_meeting_url
                      ? record.inperson_meeting_url
                      : ""
                    : record.join_url
                      ? record.join_url
                      : "";
                session.meeting_id = record.meeting_id;

                session.is_host = record.is_host;
                session.is_participant = record.is_participant;
              }
            }
            // console.log(session)
            session.date_time = _.sortBy(session.date_time, "startDateTime");
          }
        }
        setUpcomingSessionListing(upcomingSessionList);

        //for past session list
        if (!_.isEmpty(pastList)) {
          for (let session of pastList) {
            session.can_enroll = true;
            session.hostZoomId = isLoggedIn
              ? authBroker.payload.user.zoom_id
              : "";
            session.userId = isLoggedIn ? authBroker.payload.user.user_id : "";
            session.host = session.display_name;
            session.show_join = false;
            session.is_broadcast =
              session.delivery_mode === "virtual_broadcast";

            session.start_url = "";
            session.join_url = "";
            session.meeting_id = "";
            session.segmentId = "";
            session.timezoneAbbr = timezoneAbbr;
            if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
              for (let record of session.date_time) {
                if (record.start_date) {
                  session.segmentId = record.segment_id;
                  session.start_url = record.start_url ? record.start_url : "";
                  session.join_url =
                    session.delivery_mode === "blended_session"
                      ? record.inperson_meeting_url
                        ? record.inperson_meeting_url
                        : ""
                      : record.join_url
                        ? record.join_url
                        : "";
                  session.meeting_id = record.meeting_id;

                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                }
              }
              // console.log(session)
              session.date_time = _.sortBy(session.date_time, "startDateTime");
            }
          }
          setPastSessionListing(pastList);
        } else {
          setPastSessionListing([]);
        }
      } else {
        setSessionListing([]);
        setUpcomingSessionListing([]);
        setPastSessionListing([]);
        setUpcoming({});
      }

      dispatch(getSessionBrokerListClear());
    }
  }, [sessionBrokerListRes]);

  useEffect(() => {
    // console.log("Check notified", checkNotified);
    if (checkNotified.status === "success") {
      if (checkNotified.payload.payload.is_notified) {
        setNotifyMeBtn(true);
      }
      dispatch(checkEventNotificationClear());
    }
  }, [checkNotified]);

  useEffect(() => {
    if (providerId) {
      let breadCData = [
        { name: authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
          authBroker?.payload?.user?.config?.partner_menu_text:
          "Learning Partners", active: false, link: "/our-partners", isLoading: false }
      ];
      let paramsReq = {
        provider_id: providerId,
        provider_name: providerName,
      };
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      if (providerName && providerId) {
        breadCData.push({
          name: providerName,
          active: false,
          link: `/partner-detail?c=${encodedUrl}`,
          isLoading: false,
        });
      }

      breadCData.push({ name: fromCert === "true" ? "Certificate" : "Event", active: false, link: `/partner-detail/${fromCert === "true" ? 'certifications' : 'events'}/?c=${encodedUrl}`, isLoading: false })
      breadCData.push({ name: title, active: true, link: "", isLoading: false })

      setBreadCrumbData(breadCData);
    } else if (!_.isEmpty(title)) {
      let breadCData = [
        {
          name: is_home ? "Home" : "Learn",
          active: false,
          link: is_home ? "/home" : "/learn/courses?tab=1",
          isLoading: false,
        },
      ];
      let paramsReq = {
        provider_id: providerId,
        provider_name: providerName,
      };
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      if (providerName && providerId) {
        breadCData.push({
          name: providerName,
          active: false,
          link: `/partner-detail?c=${encodedUrl}`,
          isLoading: false,
        });
      }
      if (from === "lp" || from === "bundle") {
        breadCData.push({
          name: from === "bundle" ? "Combo & Offers" : "Learning Path",
          active: false,
          link:
            from === "bundle"
              ? routeList.LEARN_COMBO_PAGE
              : routeList.LEARN_LEARNING_PATH_PAGE,
          isLoading: false,
        });
        breadCData.push({
          name: eventDetail?.parent_name,
          active: false,
          link: -1,
          isLoading: false,
        });
      }
      breadCData.push({
        name: fromCert === "true" ? "Certifications" : "Events",
        active: false,
        link: providerId ? fromCert === "true" ? `/partner-detail/certifications?c=${encodedUrl}` : `/partner-detail/events?c=${encodedUrl}` : from === "lp" || from === "bundle" ? -1 : fromCert === "true" ? "/learn/certifications" : "/learn/events",
        isLoading: false,
      });
      breadCData.push({
        name: title,
        active: true,
        link: "",
        isLoading: false,
      });

      setBreadCrumbData(breadCData);
    } else {
      setTitle("");
    }
  }, [title]);

  const onNotifyMeHandler = (filterValue) => {
    console.log("check1")
    dispatch(
      eventNotification({
        module: "event_Notify_Me",
        postData: {
          event_id: eventId,
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          origin: "xsel",
          status: "checked",
        },
      })
    );

    setNotifyMeBtn(true);
  };

  const uncheckNotifyMeHandler = () => {
    dispatch(
      eventNotification({
        module: "event_Notify_Me",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          event_id: eventId,
          origin: "xsel",
          status: "unchecked",
        },
      })
    );
    setNotifyMeBtn(false);
  };

  const singlePriceUpcoming = () => {
    console.log(bannerPriceInfo);
    if (_.isEmpty(bannerPriceInfo) || bannerPriceInfo.isFree) {
      return <></>;
    }
    return ProductCardPriceInfo(
      bannerPriceInfo.showText,
      "#fce5fb"
    );
  };

  const renderRemindMeSection = () => (
    isLoggedIn && <div className="form-check side-check-box">
      <input
        className="form-check-input"
        type="checkbox"
        value=""
        id="flexCheckDefault"
        checked={notifyMeBtn ? true : ""}
        onChange={(e) => {
          if (e.target.checked) {
            onNotifyMeHandler();
          } else {
            uncheckNotifyMeHandler();
          }
        }
        }
      />
      <div className="righ-disc-sec">
        <label
          className="form-check-label"
          htmlFor="flexCheckDefault"
          checked={notifyMeBtn ? true : ""}
          onClick={(e) => {

          }}
        >
          Remind me
        </label>
        <p className="sesstion-detail">
          We will send you an email reminder at
          <br />
          {isLoggedIn ? authBroker?.payload?.user?.email : ""}
        </p>
      </div>
    </div>
  );

  useEffect(() => {
    // console.log("joinSessionData", joinSessionData);
    if (!_.isEmpty(joinSessionData)) {
      setIsLoading(false);
      setIsShowLoader(false);
      if (joinSessionData.status === "success") {
        if (!_.isEmpty(joinSessionData.payload.payload)) {
          const sessionData = joinSessionData.payload.payload;
          if (sessionData.join_url) {
            window.open(sessionData.join_url, "_blank");
          } else {
            // window.scrollTo(0, 0);
            setShowInfoModalMsg(
              "Error joining session, please contact support"
            );
            setInfoModal(true);
            // setInfoModal(true);
          }
        }
      } else {
        // console.log(joinSessionData.error.message);
        // setShowInfoModalMsg(joinSessionData.error.message);
        let msg = joinSessionData.error.message;
        // setShowInfoModalMsg(
        //   msg ? msg : "Error joining session, please contact support"
        // );
      }
      window.scrollTo(0, 0);

      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(joinSessionClear());
    }
  }, [joinSessionData]);

  useEffect(() => {
    if (!_.isEmpty(hostSessionInfo)) {
      setIsLoading(false);
      setIsShowLoader(false);
      if (hostSessionInfo.status === "success") {
        if (!_.isEmpty(hostSessionInfo.payload.payload)) {
          // console.log("hostSessionInfo", hostSessionInfo.payload.payload);
          const hostData = hostSessionInfo.payload.payload.data;
          if (hostData.start_url) {
            window.open(hostData.start_url, "_blank");
          } else {
            window.scrollTo(0, 0);
            setShowInfoModalMsg("Server Error, please contact support");
            // setInfoModal(true);
          }
          // dispatch(hostSessionClear());
        } else {
          // console.log(hostSessionInfo.error.message);
          setShowInfoModalMsg(hostSessionInfo.error.message);
          // setInfoModal(true);
        }
      } else {
        setShowInfoModalMsg(hostSessionInfo.error.message);
      }
      window.scrollTo(0, 0);
      setInfoModal(true);
      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(hostSessionClear());
    }
  }, [hostSessionInfo]);

  const registerConfirm = (session) => {

    if (!isLoggedIn) {
      navigate("/login");
    } else if (session?.is_recurring && session?.is_recurring_check) {
      setClickedItem(1);
      setSessionDataForModal(session)
      setShowModalMsg(`Registering this will enable you to auto-register for all upcoming ${session?.total_auto_reg_ssn} recurring sessions.`)
      setConfirmModal(true)
    } else {
      proceedToRegister(session)
    }

  }

  const proceedToRegister = (sessionData) => {
    // setIsLoading(true)
    // setRegister(true);

    setIsShowLoader(true);
    clickStreamUser("register-button-clicked", {
      event_id: eventId,
      session_id: sessionData.sessionId,
      session_name: sessionData.session_name,
      user_id: isLoggedIn ? authBroker?.payload.user.user_id : "",
      type: sessionData?.source,
    });
    dispatch(
      getEnrollBrokerSession({
        module: "enrollBrokerSession",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: sessionData.session_id,
          event_id: eventId,
          type: sessionData?.source,
        },
      })
    );
  };

  const cancelConfirm = (session) => {
    setClickedItem(2);
    setSessionDataForModal(session)
    setShowModalMsg('Would you like to unregister from the session?')
    setConfirmModal(true)
  }


  const cancelSession = (sessionData) => {
    clickStreamUser("cancel-session", {
      event_id: eventId,
      session_id: sessionData.session_id,
      session_name: sessionData.session_name,
      user_id: isLoggedIn ? authBroker?.payload.user.user_id : "",
    });
    setIsShowLoader(true);
    dispatch(
      cancelSessionData({
        module: "sessionCancel",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: sessionData.session_id,
          session_title: sessionData.session_name,
          event_id: eventId,
          origin: sessionData.source,
          cancel_type: sessionData.cancel_type === undefined ? "" : sessionData.cancel_type
        },
      })
    );
  };


  const proceedToPurchase = (sessionData, priceInfo1) => {
    console.log("sessiondata---", sessionData);
    if (isAndroid || isIOS) {
      try {
        let obj = {
          message: "click-on-purchase",
          productId: sessionData?.product_id,
          amount: sessionData?.purchased_info?.selling_price,
          title: sessionData?.session_name,
          provider_name:
            sessionData?.provider?.provider_display_name,
          provider_img:
            sessionData?.provider?.provider_img,
          enrolledtextAmount:
            sessionData?.purchased_info
              ?.enrolled_text,
        };
        if (window.callbackHandler != undefined) {
          window.callbackHandler.postMessage(JSON.stringify(obj));
        }
        if (window.webkit != undefined) {
          if (
            window.webkit.messageHandlers.callbackHandler !=
            undefined
          ) {
            window.webkit.messageHandlers.callbackHandler.postMessage(
              JSON.stringify(obj)
            );
          }
        }
      } catch (err) {
        console.log("error in sending message");
      }
    }
    clickStreamUser("purchase-button-clicked", {
      event_id: eventId,
      session_id: sessionData.session_id,
      session_name: sessionData.session_name,
      user_id: isLoggedIn ? authBroker?.payload.user.user_id : "",
      type: "xsel",
    });
    let tags = [];
    let logoURL = "";
    if (!_.isEmpty(sessionData.provider)) {
      tags.push(sessionData.provider.provider_display_name);
      logoURL = sessionData.provider.provider_img;
    }
    tags.push('Session')

    const sessionType = getSessionType(sessionData.delivery_mode)
    if (sessionType) tags.push(sessionType)
    if (sessionData.host) {
      tags.push(sessionData.host);
    }
    let priceInfo = _.cloneDeep(priceInfo1);
    priceInfo.isAddToCart = sessionData.is_addtocart;
    setIsOpen(true);
    setHeaderProdData({
      id: sessionData.product_id,
      title: sessionData.session_name,
      logoURL: logoURL,
      logoAltText: "ED",
      bannerURL: sessionData.thumbnailURL,
      tagsArray: tags,
      description: sessionData.session_description,
      duration: "",
      view: "",
      price: priceInfo.price,
      isPaid: !priceInfo.isFree,
      priceInfo: priceInfo,
      cancel_request: sessionData.cancel_request,
    });
  };


  const launchSession = (session) => {
    clickStreamUser("launch-session", {
      event_id: eventId,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: isLoggedIn ? authBroker.payload.user.user_id : "",
    });
    if (session.is_broadcast) {
      console.log("session_type: ", "brodcast");
      dispatch(
        boardcastDataResponse({
          eventId: eventId,
          sessionId: session.session_id,
          source: session.source,
        })
      );
      navigate("/session/broadcast/watch");
    } else {
      if (session.join_url) {
        console.log("session_type: ", "joinUrlVirtual");
        window.open(session.join_url, "_blank");
      } else {
        console.log("session_type: ", "meetingVirtual");
        setIsShowLoader(true);
        dispatch(
          joinSession({
            module: "joinZoomMeeting",
            postData: {
              user_id: isLoggedIn ? authBroker.payload.user.user_id : "",
              meeting_id: session?.date_time[0]?.meeting_id,
              session_id: session.session_id,
              segment_id: session?.date_time[0]?.segment_id,
            },
          })
        );
      }
    }
  };

  const proceedToHost = (session) => {
    if (session.is_broadcast) {
      dispatch(
        boardcastDataResponse({
          eventId: eventId,
          sessionId: session.session_id,
          source: session.source,
        })
      );
      navigate("/session/broadcast/watch");
    } else {
      if (session.start_url) {
        window.open(session.start_url, "_blank");
      } else {
        dispatch(
          hostSession({
            module: "createZoomMeeting",
            postData: {
              user_id: session.userId,
              host_zoom_id: session.hostZoomId,
              meeting_topic: session.session_name,
              meeting_agaenda: session.session_name,
              meeting_startdate:
                moment.utc(session.startUTC).format("YYYY-MM-DD HH:mm") + ":00",
              duration: _.toNumber(session.durationValue),
              session_id: session.session_id,
              segment_id: session.segmentId,
            },
          })
        );
        setIsLoading(true);
        // setIsShowLoader(true);
      }
    }
  };

  useEffect(() => {
    console.log("sessionCalledData", sessionCancelledData);
    if (!_.isEmpty(sessionCancelledData)) {
      setIsShowLoader(false);
      // setRegister(!register);
      sessionsApiCalling();
      if (sessionCancelledData.status === "success") {
        // setRegister(true);
        // setInfoModal(true);
        // fetchSessionList({ origin: source });
        window.scrollTo(0, 0);
        if (source === "broker") {
          setShowInfoModalMsg(
            "You have successfully unregistered from the session."
          );
        } else {
          setShowInfoModalMsg("Xsel team will connect with you shortly.");
        }
        let data = {
          origin: source,
        };
        // fetchSessionList(data)
      } else {
        setShowInfoModalMsg("Error cancelling session.");

        window.scrollTo(0, 0);
      }
      setIsConfirm(false);
      setInfoModal(true);
      setIsLoading(false);

      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(cancelSessionDataClear());
    }
  }, [sessionCancelledData]);

  useEffect(() => {
    // console.log("enrolled", enrollBrokerSession);
    if (!_.isEmpty(enrollBrokerSession)) {
      setIsShowLoader(false);
      // dispatchAPICall();
      if (enrollBrokerSession?.status === "success") {
        // setRegister(!register);
        sessionsApiCalling();
      }
    }
  }, [enrollBrokerSession]);

  return (
    <>
      <Loader start={isShowLoader} />
      {!isSessionLoading && _.isEmpty(eventDetail) ? <NotFoundComponent showMsg={true} /> :
        <section className="bannersection-sec">
          <div className="bannersection bgba">
            <div className="bannerrimg">
              {isSessionLoading ? (
                <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
              ) : (
                <img src={eventDetail.banner} alt="banner-img" />
              )}
            </div>
{(upcomingSessionListing != null &&
                    upcomingSessionListing.length === 0 )||(_.isEmpty(bannerPriceInfo) ||
                        bannerPriceInfo?.isFree)?<></> : <div className={scrolled ? "bb-sec scrolled" : "bb-sec"}>
              <div className="container d-flex align-items-center justify-content-end cont-baner">
                <div className="button-box">
                  {isFetching ? (
                    ""
                  ) : upcomingSessionListing != null &&
                    upcomingSessionListing.length === 0 ? (
                    ""
                  ) : (
                    <>
                      <span>{singlePriceUpcoming()}</span>
                      {!_.isEmpty(bannerPriceInfo) &&
                        !bannerPriceInfo?.isFree &&
                        !bannerPriceInfo?.isPurchased && (
                          <button
                            type="button"
                            className="startcourse-btn"
                            onClick={() =>
                              proceedToPurchase(
                                upcomingSessionDetail,
                                bannerPriceInfo
                              )
                            }
                          >
                            Purchase
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#6941C6"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        )}
                    </>
                  )}
                </div>

                {false && <div className="bannershare-btn">
                  <Dropdown className="customdropdown-btn">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                      >
                        <path
                          d="M30 36.6666C28.6111 36.6666 27.4306 36.1805 26.4583 35.2083C25.4861 34.236 25 33.0555 25 31.6666C25 31.4721 25.0139 31.2708 25.0417 31.0624C25.0694 30.8541 25.1111 30.6666 25.1667 30.4999L13.4167 23.6666C12.9444 24.0833 12.4167 24.4096 11.8333 24.6458C11.25 24.8819 10.6389 24.9999 10 24.9999C8.61111 24.9999 7.43056 24.5138 6.45833 23.5416C5.48611 22.5694 5 21.3888 5 19.9999C5 18.611 5.48611 17.4305 6.45833 16.4583C7.43056 15.486 8.61111 14.9999 10 14.9999C10.6389 14.9999 11.25 15.118 11.8333 15.3541C12.4167 15.5902 12.9444 15.9166 13.4167 16.3333L25.1667 9.49992C25.1111 9.33325 25.0694 9.14575 25.0417 8.93742C25.0139 8.72908 25 8.5277 25 8.33325C25 6.94436 25.4861 5.76381 26.4583 4.79159C27.4306 3.81936 28.6111 3.33325 30 3.33325C31.3889 3.33325 32.5694 3.81936 33.5417 4.79159C34.5139 5.76381 35 6.94436 35 8.33325C35 9.72214 34.5139 10.9027 33.5417 11.8749C32.5694 12.8471 31.3889 13.3333 30 13.3333C29.3611 13.3333 28.75 13.2152 28.1667 12.9791C27.5833 12.743 27.0556 12.4166 26.5833 11.9999L14.8333 18.8333C14.8889 18.9999 14.9306 19.1874 14.9583 19.3958C14.9861 19.6041 15 19.8055 15 19.9999C15 20.1944 14.9861 20.3958 14.9583 20.6041C14.9306 20.8124 14.8889 20.9999 14.8333 21.1666L26.5833 27.9999C27.0556 27.5833 27.5833 27.2569 28.1667 27.0208C28.75 26.7846 29.3611 26.6666 30 26.6666C31.3889 26.6666 32.5694 27.1527 33.5417 28.1249C34.5139 29.0971 35 30.2777 35 31.6666C35 33.0555 34.5139 34.236 33.5417 35.2083C32.5694 36.1805 31.3889 36.6666 30 36.6666ZM30 9.99992C30.4722 9.99992 30.8681 9.8402 31.1875 9.52075C31.5069 9.20131 31.6667 8.80547 31.6667 8.33325C31.6667 7.86103 31.5069 7.4652 31.1875 7.14575C30.8681 6.82631 30.4722 6.66658 30 6.66658C29.5278 6.66658 29.1319 6.82631 28.8125 7.14575C28.4931 7.4652 28.3333 7.86103 28.3333 8.33325C28.3333 8.80547 28.4931 9.20131 28.8125 9.52075C29.1319 9.8402 29.5278 9.99992 30 9.99992ZM10 21.6666C10.4722 21.6666 10.8681 21.5069 11.1875 21.1874C11.5069 20.868 11.6667 20.4721 11.6667 19.9999C11.6667 19.5277 11.5069 19.1319 11.1875 18.8124C10.8681 18.493 10.4722 18.3333 10 18.3333C9.52778 18.3333 9.13194 18.493 8.8125 18.8124C8.49306 19.1319 8.33333 19.5277 8.33333 19.9999C8.33333 20.4721 8.49306 20.868 8.8125 21.1874C9.13194 21.5069 9.52778 21.6666 10 21.6666ZM30 33.3333C30.4722 33.3333 30.8681 33.1735 31.1875 32.8541C31.5069 32.5346 31.6667 32.1388 31.6667 31.6666C31.6667 31.1944 31.5069 30.7985 31.1875 30.4791C30.8681 30.1596 30.4722 29.9999 30 29.9999C29.5278 29.9999 29.1319 30.1596 28.8125 30.4791C28.4931 30.7985 28.3333 31.1944 28.3333 31.6666C28.3333 32.1388 28.4931 32.5346 28.8125 32.8541C29.1319 33.1735 29.5278 33.3333 30 33.3333Z"
                          fill="white"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 21L10.55 19.7C8.86667 18.1833 7.475 16.875 6.375 15.775C5.275 14.675 4.4 13.6875 3.75 12.8125C3.1 11.9375 2.64583 11.1333 2.3875 10.4C2.12917 9.66666 2 8.91666 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.36667 2.64999 9.19167 2.83333 9.975 3.19999C10.7583 3.56666 11.4333 4.08333 12 4.74999C12.5667 4.08333 13.2417 3.56666 14.025 3.19999C14.8083 2.83333 15.6333 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 8.91666 21.8708 9.66666 21.6125 10.4C21.3542 11.1333 20.9 11.9375 20.25 12.8125C19.6 13.6875 18.725 14.675 17.625 15.775C16.525 16.875 15.1333 18.1833 13.45 19.7L12 21ZM12 18.3C13.6 16.8667 14.9167 15.6375 15.95 14.6125C16.9833 13.5875 17.8 12.6958 18.4 11.9375C19 11.1792 19.4167 10.5042 19.65 9.91249C19.8833 9.32083 20 8.73333 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 14.9917 4.87083 14.325 5.31249C13.6583 5.75416 13.2 6.31666 12.95 6.99999H11.05C10.8 6.31666 10.3417 5.75416 9.675 5.31249C9.00833 4.87083 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 8.73333 4.11667 9.32083 4.35 9.91249C4.58333 10.5042 5 11.1792 5.6 11.9375C6.2 12.6958 7.01667 13.5875 8.05 14.6125C9.08333 15.6375 10.4 16.8667 12 18.3Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Like
                      </div>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Share
                      </div>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M5 21V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V21L12 18L5 21ZM7 17.95L12 15.8L17 17.95V5H7V17.95Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Bookmark
                      </div>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Save to Wishlist
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>}
              </div>
            </div>}
          </div>
          <div className="container">
            <BreadCrumbComponent crumbList={breadCrumbData} />
            <div className="row">
              <div className="col-xl-7">
                <div className="module-learn-text mt-0">
                  {isSessionLoading ? (
                    <div className="mgt30 mb-3">
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"50px"}
                      />
                    </div>
                  ) : (
                    <h2 className="mgt30">{title}</h2>
                  )}

                  {isLoading ? (
                    <ul className="learncourselistt-row mb-3">
                      <li>
                        <ShimmerScreen
                          case={"rect"}
                          width={"80px"}
                          height={"25px"}
                        />
                      </li>
                      <li>
                        <ShimmerScreen
                          case={"rect"}
                          width={"80px"}
                          height={"25px"}
                        />
                      </li>
                    </ul>
                  ) : (
                    upcomingSessionListing.length > 0 && (
                      <div className="d-flex box-meta">
                        <div className="img-box-meta">
                          <img
                            src={
                              upcomingSessionDetail.provider
                                ? upcomingSessionDetail.provider.provider_img
                                : ""
                            }
                          />
                        </div>
                        <div className="meta-lsit">
                          <ul className="learncourselistt-row">
                            <li>
                              {" "}
                              {upcomingSessionDetail.provider
                                ? upcomingSessionDetail.provider
                                  .provider_display_name
                                : ""}{" "}
                            </li>
                            <li>Session</li>
                            <li>
                              {getSessionType(upcomingSessionDetail.delivery_mode)}
                            </li>
                            <li>
                              {upcomingSessionDetail.host
                                ? upcomingSessionDetail.host
                                : ""}{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    )
                  )}

                  {isSessionLoading ? (
                    <ShimmerScreen case="rect" width="60%" height="7rem" />
                  ) : (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: eventDetail.description,
                      }}
                    ></p>
                  )}
                </div>
              </div>
              <div className="col-xl-5">
                <div className="mb-4">
                  <RightPanelComponent
                    id={eventDetail?.event_id}
                    parentName={"event"}
                    code={eventDetail?.event_code}
                    moduleData={eventDetail}
                    type={"event"}
                    source={eventDetail?.origin}
                    isMobile={false}
                  />
                </div>
                <div className="right-panel">
                  <div className="contsection">
                    <Tabs
                      defaultActiveKey="upcoming-sessions"
                      transition={false}
                      id="noanim-tab-example"
                      className="mb-3"
                    >
                      <Tab eventKey="upcoming-sessions" title="Upcoming Sessions">
                        <div className="upcoming-content">
                          {isLoading ? (
                            <div className="mt-5">
                              <h4>
                                <ShimmerScreen
                                  case="rect"
                                  width="100%"
                                  height="2rem"
                                />
                              </h4>

                              <div className="price-bar">
                                <ShimmerScreen
                                  case="rect"
                                  width="100%"
                                  height="2rem"
                                />
                              </div>

                              <div className="Segmentbar">
                                <ShimmerScreen
                                  case="rect"
                                  width="100%"
                                  height="4rem"
                                />
                              </div>
                            </div>
                          ) : upcomingSessionListing != null &&
                            upcomingSessionListing.length === 0 ? (
                            <>
                              <ErrorSectionSidebar />
                              {source !== "broker" && renderRemindMeSection()}
                            </>
                          ) : (
                            <>
                              <div className="session-wrapper">
                                {upcomingSessionListing.map((item, index) => {
                                  let priceInfo1 = getProcureInfo(item.purchased_info);
                                  console.log("item--", item);
                                  const isUserRegistered = () => {
                                    return item.is_registered; // Replace with your logic
                                  };
                                  return (
                                    <div className="mt-inner-sec mt-4" key={index}>
                                      <div className="d-flex user-table-box">
                                        <div className="brokarage-icon">
                                          <img
                                            src={
                                              !_.isEmpty(item?.provider)
                                                ? item?.provider?.provider_img
                                                : "https://cdnstg.training.com/xsel/image/6e139227-97e8-4726-9a03-2dd339cfff53.jpg"
                                            }
                                          />
                                        </div>
                                        <h4 className="event-sidebar-title">
                                          {item.session_name}
                                        </h4>
                                      </div>

                                      {item.date_time.map((segment, i) => {
                                        return (
                                          <>
                                            <div className="Segmentbar" key={i}>
                                              <p className="sesstion-detail-head">
                                                {segment.segment_title}
                                              </p>
                                              <p className="sesstion-detail">
                                                {formatStartDateTime(
                                                  segment.start_date,
                                                  segment.start_time,
                                                  item.timezoneAbbr
                                                )}
                                              </p>
                                              <p className="sesstion-detail">
                                                {formatEndDateTime(
                                                  segment.end_date,
                                                  segment.end_time,
                                                  item.timezoneAbbr
                                                )}
                                              </p>

                                              <div className="event-details">
                                                <ul>
                                                  <li>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="25"
                                                      height="25"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M15.3033 14.4701L10 19.7733L4.6967 14.4701C1.76777 11.5411 1.76777 6.79238 4.6967 3.86345C7.62563 0.934515 12.3743 0.934515 15.3033 3.86345C18.2323 6.79238 18.2323 11.5411 15.3033 14.4701ZM10 12.5001C11.8409 12.5001 13.3333 11.0077 13.3333 9.16675C13.3333 7.3258 11.8409 5.83341 10 5.83341C8.15905 5.83341 6.66667 7.3258 6.66667 9.16675C6.66667 11.0077 8.15905 12.5001 10 12.5001ZM10 10.8334C9.0795 10.8334 8.33333 10.0872 8.33333 9.16675C8.33333 8.24627 9.0795 7.50008 10 7.50008C10.9205 7.50008 11.6667 8.24627 11.6667 9.16675C11.6667 10.0872 10.9205 10.8334 10 10.8334Z"
                                                        fill="#6941C6"
                                                      />
                                                    </svg>
                                                    <span className="text-ec">
                                                      {item.delivery_mode ===
                                                        "blended_session" ? (
                                                        <>
                                                          {"In-Person/Virtual (" +
                                                            item.location +
                                                            ")"}
                                                        </>
                                                      ) : item.delivery_mode ===
                                                        "face_to_face" ? (
                                                        <>
                                                          {"In-Person (" +
                                                            item.location +
                                                            ")"}
                                                        </>
                                                      ) : item.delivery_mode ===
                                                        "virtual_interactive" ||
                                                        item.delivery_mode ===
                                                        "virtual_broadcast" ? (
                                                        "Virtual"
                                                      ) : (
                                                        "Live"
                                                      )}
                                                    </span>
                                                  </li>
                                                  <li>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 24 24" ><path d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM11 13V17H6V13H11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z" fill="#7f56d9"></path></svg>
                                                    <span className="text-ec">{"Seats Booked: " + item.seats_booked}</span>
                                                  </li>
                                                  <li>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 24 24" ><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z" fill="#7f56d9"></path></svg>
                                                    <span className="text-ec">{"Seats Available: " +
                                                      item.seats_available}</span>
                                                  </li>
                                                </ul>
                                              </div>
                                              {/* <p className="sesstion-detail-head">
                                     
                                      <span className="bookedtext">{"Seats Booked: " + item.seats_booked}</span>
                                      </p>
                                      <p className="sesstion-detail-head">
                                      <svg xmlns="http://www.w3.org/2000/svg"  width={24} height={24} viewBox="0 0 24 24" ><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z" fill="#7f56d9"></path></svg>
                                      <span className="bookedtext">{"Seats Available: " +
                                          item.seats_available}</span>
                                      </p> */}
                                            </div>
                                          </>
                                        );
                                      })}
                                      <div className="Segmentbar">
                                        {!item?.is_host && source != "broker" && !_.isEmpty(priceInfo1)
                                          ? ProductCardPriceInfo(
                                            priceInfo1.showText,
                                            priceInfo1.textColor
                                          )
                                          : ""}
                                      </div>
                                      <div className="certificate-btn-sec">

                                        {item?.is_host ? (
                                          item.delivery_mode ===
                                            "face_to_face"  ? (
                                            <></>
                                          ) : (
                                            <>
                                              {isSessionWithinOneHour(
                                                item.date_time[0].start_date,
                                                item.date_time[0].start_time,
                                                item.date_time[0].end_date,
                                                item.date_time[0].end_time,
                                                item.timezoneAbbr
                                              ) ? (
                                                <button
                                                  type="button"
                                                  className={`startcourse-btn cursor-pointer`}
                                                  onClick={() => {
                                                    proceedToHost(item);
                                                  }}
                                                >
                                                  Host
                                                </button>
                                              ) : (
                                                <button
                                                  type="button"
                                                  className={`startcourse-btn cursor-not-allowed`}
                                                  disabled
                                                >
                                                  Host
                                                </button>
                                              )}
                                            </>
                                          )
                                        ) : (priceInfo1.isFree || source == "broker") &&
                                          isUserRegistered() == false ? (
                                          <button
                                            type="button"
                                            className="startcourse-btn"
                                            onClick={() => registerConfirm(item)}
                                          >
                                            {isLoggedIn
                                              ? "Register now"
                                              : "Signup to Register"}
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                            >
                                              <path
                                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                stroke="#6941C6"
                                                strokeWidth="1.66667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                          </button>
                                        ) : isSessionWithinOneHour(
                                          item.date_time[0]?.start_date,
                                          item.date_time[0]?.start_time,
                                          item.date_time[0]?.end_date,
                                          item.date_time[0]?.end_time,
                                          item.timezoneAbbr
                                        ) && isUserRegistered() == true ? item.delivery_mode === "face_to_face" ? <></> : (
                                          <button
                                            type="button"
                                            className="startcourse-btn"
                                            onClick={() => launchSession(item)}
                                          >
                                            Join
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                            >
                                              <path
                                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                stroke="#6941C6"
                                                strokeWidth="1.66667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                          </button>
                                        ) : isUserRegistered() == true ? (
                                          <>
                                            {item.delivery_mode !== "face_to_face" && <button
                                              type="button"
                                              className="startcourse-btn cursor-not-allowed"
                                            >
                                              Join
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                              >
                                                <path
                                                  d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                  stroke="#6941C6"
                                                  strokeWidth="1.66667"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                            </button>
                                            }
                                            <button
                                              type="button"
                                              className={
                                                item.cancel_request
                                                  ? "startcourse-btn disable-button"
                                                  : "startcourse-btn"
                                              }
                                              disabled={item.cancel_request}
                                              onClick={() => cancelConfirm(item)}
                                              title={
                                                item.cancel_request
                                                  ? "Your session cancellation request is still pending."
                                                  : ""
                                              }
                                            >
                                              Cancel
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                              >
                                                <path
                                                  d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                  stroke="#6941C6"
                                                  strokeWidth="1.66667"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                            </button>
                                          </>
                                        ) : (
                                          <button
                                            type="button"
                                            className="startcourse-btn"
                                            onClick={() =>
                                              proceedToPurchase(item, priceInfo1)
                                            }
                                          >
                                            Purchase
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                            >
                                              <path
                                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                stroke="#6941C6"
                                                strokeWidth="1.66667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                          </button>
                                        )}
                                      </div>

                                      {(userRole === "manager" &&
          ((item?.purchased_info?.selling_price === 0 && item?.purchased_info?.is_purchased !== true) ||
            source === "broker")) ||
        (userRole === "manager" && (from === "lp" || from === "oblp") && source === "broker") ||
        (userRole === "manager" &&
          (from === "lp" || from === "oblp") && 
          item?.purchased_info?.is_purchased !== true &&
          item?.purchased_info?.selling_price === 0) ? (
                                        <div className="team-assign-sec   mt-4">
                                          <div className="text-box-rs d-flex align-items-center">
                                            <div className="img-leftbef">
                                              <img src="/images/TeamBenefit.svg" />
                                            </div>
                                            <div className="benefot">
                                              <p className="m-0">
                                                Get your team to benefit from this
                                                session.
                                              </p>
                                            </div>
                                          </div>
                                          <div className="button-sec-assign mt-3 d-flex gap-2 align-items-center">
                                            <button
                                              type="button"
                                              className="startcourse-btn"
                                              onClick={() => {
                                                dispatch(setCurrentView(1));
                                                setShow(true);
                                                setSelectedSession(
                                                  source === "broker"
                                                    ? item.session_id
                                                    : item.product_id
                                                );
                                              }}
                                            >
                                              + Assign
                                            </button>
                                            <button
                                              type="button"
                                              className="startcourse-btn"
                                              onClick={() => {
                                                let parentId = source === "broker" ? item.session_id : item.product_id;
                                                let origin = (source === "xsel" || source === "ecom") ? "xsel" : "broker";
                                                let pName = fromCert==="true"?'Certificate':"Session"
                                                navigate(
                                                  "/assigned-users?parentId=" +
                                                  parentId +
                                                  "&origin=" +
                                                  origin +
                                                  "&parentName=" + pName + "&isMobile=" +
                                                  false //isMobile
                                                );
                                              }}
                                            >
                                              View Assigned
                                            </button>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  );
                                })}
                              </div>

                              {source !== "broker" && renderRemindMeSection()}
                            </>
                          )}
                          <CartPopUpComponent
                            isOpen={isOpen}
                            productData={headerProdData}
                            closeAction={() => setIsOpen(false)}
                            isSubscription={false}
                            setMainPageLoading={setIsLoading}
                          />
                        </div>
                      </Tab>
                      {isLoggedIn &&
                        <Tab eventKey="past-sessions" title="Past Sessions">
                          <div className="past-tab-content">
                            {isLoading ? (
                              <div className="mt-5">
                                <h4>
                                  <ShimmerScreen
                                    case="rect"
                                    width="100%"
                                    height="2rem"
                                  />
                                </h4>

                                <div className="price-bar">
                                  <ShimmerScreen
                                    case="rect"
                                    width="100%"
                                    height="2rem"
                                  />
                                </div>

                                <div className="Segmentbar">
                                  <ShimmerScreen
                                    case="rect"
                                    width="100%"
                                    height="4rem"
                                  />
                                </div>
                              </div>
                            ) : pastSessionListing != null &&
                              pastSessionListing.length === 0 ? (
                              <>
                                <ErrorSectionSidebar />
                                {source !== "broker" && renderRemindMeSection()}
                              </>
                            ) : (
                              <>
                                <div className="session-wrapper">
                                  {pastSessionListing.map((item, index) => {
                                    let priceInfo1 = getProcureInfo(item.purchased_info);
                                    console.log("item--", item);
                                    const isUserRegistered = () => {
                                      return item.is_registered; // Replace with your logic
                                    };
                                    return (
                                      <div className="mt-inner-sec mt-4" key={index}>
                                        <div className="d-flex user-table-box">
                                          <div className="brokarage-icon">
                                            <img
                                              src={
                                                !_.isEmpty(item?.provider)
                                                  ? item?.provider?.provider_img
                                                  : "https://cdnstg.training.com/xsel/image/6e139227-97e8-4726-9a03-2dd339cfff53.jpg"
                                              }
                                            />
                                          </div>
                                          <h4 className="event-sidebar-title">
                                            {item.session_name}
                                          </h4>
                                        </div>

                                        {item.date_time.map((segment, i) => {
                                          return (
                                            <>
                                              <div className="Segmentbar" key={i}>
                                                <p className="sesstion-detail-head">
                                                  {segment.segment_title}
                                                </p>
                                                <p className="sesstion-detail">
                                                  {formatStartDateTime(
                                                    segment.start_date,
                                                    segment.start_time,
                                                    item.timezoneAbbr
                                                  )}
                                                </p>
                                                <p className="sesstion-detail">
                                                  {formatEndDateTime(
                                                    segment.end_date,
                                                    segment.end_time,
                                                    item.timezoneAbbr
                                                  )}
                                                </p>
                                              </div>
                                            </>
                                          );
                                        })}

                                        <div className="Segmentbar">
                                          <div className="event-details">
                                            <ul>
                                              <li>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="25"
                                                  height="25"
                                                  viewBox="0 0 20 20"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M15.3033 14.4701L10 19.7733L4.6967 14.4701C1.76777 11.5411 1.76777 6.79238 4.6967 3.86345C7.62563 0.934515 12.3743 0.934515 15.3033 3.86345C18.2323 6.79238 18.2323 11.5411 15.3033 14.4701ZM10 12.5001C11.8409 12.5001 13.3333 11.0077 13.3333 9.16675C13.3333 7.3258 11.8409 5.83341 10 5.83341C8.15905 5.83341 6.66667 7.3258 6.66667 9.16675C6.66667 11.0077 8.15905 12.5001 10 12.5001ZM10 10.8334C9.0795 10.8334 8.33333 10.0872 8.33333 9.16675C8.33333 8.24627 9.0795 7.50008 10 7.50008C10.9205 7.50008 11.6667 8.24627 11.6667 9.16675C11.6667 10.0872 10.9205 10.8334 10 10.8334Z"
                                                    fill="#6941C6"
                                                  />
                                                </svg>
                                                <span className="text-ec">
                                                  {item.delivery_mode ===
                                                    "blended_session" ? (
                                                    <>
                                                      {"In-Person/Virtual (" +
                                                        item.location +
                                                        ")"}
                                                    </>
                                                  ) : item.delivery_mode ===
                                                    "face_to_face" ? (
                                                    <>
                                                      {"In-Person (" +
                                                        item.location +
                                                        ")"}
                                                    </>
                                                  ) : item.delivery_mode ===
                                                    "virtual_interactive" ||
                                                    item.delivery_mode ===
                                                    "virtual_broadcast" ? (
                                                    "Virtual"
                                                  ) : (
                                                    "Live"
                                                  )}
                                                </span>
                                              </li>
                                              <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 24 24" ><path d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM11 13V17H6V13H11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z" fill="#7f56d9"></path></svg>
                                                <span className="text-ec">{"Seats Booked: " + item.seats_booked}</span>
                                              </li>
                                              <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 24 24" ><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z" fill="#7f56d9"></path></svg>
                                                <span className="text-ec">{"Seats Available: " +
                                                  item.seats_available}</span>
                                              </li>
                                            </ul>
                                          </div>
                                          {/* <p className="sesstion-detail-head">
                                  {"Seats Booked: " + item.seats_booked}
                                </p>
                                <p className="sesstion-detail-head">
                                  {"Seats Available: " + item.seats_available}
                                </p> */}
                                        </div>

                                        <div className="certificate-btn-sec">
                                          {source != "broker" && !_.isEmpty(priceInfo1)
                                            ? ProductCardPriceInfo(
                                              priceInfo1.showText,
                                              priceInfo1.textColor
                                            )
                                            : ""}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                                {source !== "broker" && renderRemindMeSection()}

                              </>
                            )}
                          </div>
                        </Tab>}
                    </Tabs>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      }
      <ConfirmModal
        confirmModal={infoModal}
        setConfirmModal={setInfoModal}
        showModalMsg={showInfoModalMsg}
        isConfirm={isConfirm}
        confirmId={""}
        confirmAction={() => { }}
        isRightIcon={!isConfirm}
      />
      <AssignCourseModal
        show={show}
        parentName={fromCert==="true"?'Certificate Session':"Event Session"}
        parentId={selectedSession}
        setShow={setShow}
        origin={source === "xsel" || source === "ecom" ? "xsel" : "broker"}
        isMobile={false}
      />
      {confirmModal ? <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={true}
        confirmId={sessionDataForModal}
        confirmAction={clickedItem === 2 ? cancelSession : proceedToRegister}
        clickedItem={clickedItem}
        noAction={() => { }}
      /> : ""}
    </>
  );
}

export default EventDetailsSection;
